// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"e421e458","422":"7611b1cb","874":"86cfe497","969":"a867bc61"}[chunkId] + ".chunk.js";
};